import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Non-amber, non-critical tints. `--critical` is absent for the same
 * reason as amber: severity has its own chip on these rows and a tenant
 * must never read as one. Regulatory-purple is absent per Contract C5
 * (reserved for citation surfaces). Three tones, not N: this is a
 * scanning aid, and a longer ramp only invites reading meaning into it.
 */
const SWATCH_TONES = [
    'var(--band-blue-mark)',
    'var(--band-green-mark)',
    'var(--secondary)',
];
function toneFor(key) {
    let h = 0;
    for (let i = 0; i < key.length; i += 1)
        h = (h * 31 + key.charCodeAt(i)) >>> 0;
    return SWATCH_TONES[h % SWATCH_TONES.length];
}
function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return 'WS';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}
export function WorkspaceTag({ name, slug, compact = false, className, }) {
    const tone = toneFor(slug ?? name);
    return (_jsxs("span", { className: className, "data-workspace-tag": true, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            maxWidth: '14rem',
            padding: '1px 8px 1px 4px',
            borderRadius: '9999px',
            border: '1px solid var(--border)',
            background: 'var(--surface-elevated)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-3xs)',
            fontWeight: 600,
            color: 'var(--text-muted)',
        }, children: [_jsx("span", { "aria-hidden": "true", style: {
                    width: '8px',
                    height: '8px',
                    borderRadius: '2px',
                    background: tone,
                    flex: '0 0 auto',
                } }), compact ? _jsx("span", { className: "sr-only", children: name }) : null, _jsx("span", { "aria-hidden": compact ? 'true' : undefined, style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }, children: compact ? initials(name) : name })] }));
}
//# sourceMappingURL=WorkspaceTag.js.map